
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/edencommingsoon",
      function () {
        return require("private-next-pages/edencommingsoon.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/edencommingsoon"])
      });
    }
  